import React, { type ReactElement } from 'react';

const NoMatchIcon = (): ReactElement => (
  <svg
    width="16"
    height="16"
    viewBox="1 -2 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>No Match Icon</title>
    <path
      d="M18 11H6C5.4 11 5 11.4 5 12C5 12.6 5.4 13 6 13H18C18.6 13 19 12.6 19 12C19 11.4 18.6 11 18 11Z"
      fill="#2E3849"
    />
  </svg>
);

export default NoMatchIcon;
